module.exports = __webpack_public_path__ + "static/media/page08_org.fb1d4cbe.jpg";